var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import EmblaCarousel from 'embla-carousel';
import AutoScroll from 'embla-carousel-auto-scroll';
var defaultAutoScrollOptions = {
    speed: 0.85,
    stopOnInteraction: false,
    stopOnMouseEnter: false,
};
function parseJsonAttr(raw, fallback) {
    if (!raw) {
        return fallback;
    }
    try {
        return __assign(__assign({}, fallback), JSON.parse(raw));
    }
    catch (_a) {
        return fallback;
    }
}
/**
 * Initialisiert alle Viewports mit `data-cowp-embla` (z. B. im Hero).
 * `data-cowp-embla="auto-scroll"` → Embla + Auto-Scroll-Plugin.
 *
 * Markup: Viewport `.cowp-embla` mit Kind `.cowp-embla__container` und
 * `.cowp-embla__slide` (siehe Embla „Required Setup“).
 */
export function initCowpEmblaCarousels(root) {
    if (root === void 0) { root = document; }
    var apis = [];
    root.querySelectorAll('[data-cowp-embla]').forEach(function (viewport) {
        var mode = viewport.getAttribute('data-cowp-embla');
        var emblaOptions = parseJsonAttr(viewport.getAttribute('data-cowp-embla-options'), { loop: true, align: 'start' });
        var autoScrollOpts = __assign({}, parseJsonAttr(viewport.getAttribute('data-cowp-embla-autoscroll'), __assign({}, defaultAutoScrollOptions)));
        var directionAttr = viewport.getAttribute('data-cowp-embla-autoscroll-direction');
        if (directionAttr === 'forward' || directionAttr === 'backward') {
            autoScrollOpts.direction = directionAttr;
        }
        var plugins = collectPlugins(mode, autoScrollOpts);
        apis.push(EmblaCarousel(viewport, emblaOptions, plugins));
    });
    return apis;
}
var collectPlugins = function (mode, autoScrollOpts) {
    if (!mode)
        return [];
    switch (mode) {
        case 'auto-scroll':
            return [AutoScroll(autoScrollOpts)];
        default:
            return [];
    }
};
export var cowpEmbla = {
    EmblaCarousel: EmblaCarousel,
    AutoScroll: AutoScroll,
    initCowpEmblaCarousels: initCowpEmblaCarousels,
};
if (typeof window !== 'undefined') {
    window.cowpEmbla = cowpEmbla;
}
